module.exports = __webpack_public_path__ + "media/markers/cluster-active-1c0f2862.png";